/* Enjouet — catégories en accordéon (+ / −) sur les pages collection.
   Deux façons de créer des sous-catégories dans le menu "Catégories" :
   1) Recommandé : glisser un lien EN RETRAIT sous une catégorie (sous-menu Shopify).
   2) Ancienne méthode : un titre entre tirets ("- Jouets -") suivi de ses liens. */
(function () {
  var uid = 0;

  function cleanName(text) {
    var t = (text || '').trim();
    if (t.charAt(0) !== '-') return null;
    t = t.slice(1).trim();
    if (t.slice(-1) === '-') t = t.slice(0, -1).trim();
    return t;
  }

  function setOpen(li, open) {
    li.classList.toggle('is-open', open);
    var b = li.querySelector(':scope > .enj2-tog');
    if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function addToggle(li, sub, name) {
    if (!sub.id) sub.id = 'enj2-sub-' + (++uid);
    sub.classList.add('enj2-sub');
    li.classList.add('enj2-grp');
    li.classList.remove('opened', 'showAny');
    var b = li.querySelector(':scope > .enj2-tog');
    if (!b) {
      b = document.createElement('button');
      b.type = 'button';
      b.className = 'enj2-tog';
      var a = li.querySelector(':scope > a');
      if (a && a.nextSibling) li.insertBefore(b, a.nextSibling); else li.appendChild(b);
    }
    b.setAttribute('aria-controls', sub.id);
    b.setAttribute('aria-label', 'Sous-catégories : ' + name);
    var cur = li.classList.contains('current-cat') || !!sub.querySelector('.current-cat');
    setOpen(li, cur);
  }

  function build(ul) {
    if (ul.getAttribute('data-enj2-acc')) return;
    var items = Array.prototype.filter.call(ul.children, function (n) { return n.tagName === 'LI'; });
    if (!items.length) return;
    ul.setAttribute('data-enj2-acc', '1');
    ul.classList.add('enj2-acc');

    var cur = null, sub = null;
    items.forEach(function (li) {
      var lab = li.querySelector(':scope > a .custom-control-label');
      var raw = lab ? lab.textContent : '';
      var dashed = cleanName(raw);
      if (lab && dashed !== null) lab.textContent = dashed;
      var name = dashed !== null ? dashed : raw.trim();

      // 1) Vrai sous-menu Shopify (liens en retrait)
      var native = li.querySelector(':scope > ul');
      if (native && native.querySelector('li')) {
        addToggle(li, native, name);
        cur = null; sub = null;
        return;
      }
      // 2) Ancienne méthode : titre entre tirets
      if (dashed !== null) {
        li.classList.add('enj2-grp');
        sub = document.createElement('ul');
        sub.className = 'list-unstyled';
        li.appendChild(sub);
        cur = li;
        return;
      }
      if (cur) { sub.appendChild(li); return; }
      li.classList.add('enj2-grp', 'enj2-grp--solo');
    });

    // Titres entre tirets : bouton seulement s'il y a des sous-catégories
    Array.prototype.forEach.call(ul.querySelectorAll(':scope > li.enj2-grp'), function (g) {
      if (g.querySelector(':scope > .enj2-tog')) return;
      var s = g.querySelector(':scope > ul');
      var lab = g.querySelector(':scope > a .custom-control-label');
      if (s && s.children.length) {
        addToggle(g, s, lab ? lab.textContent.trim() : '');
      } else {
        if (s) s.remove();
        g.classList.add('enj2-grp--solo');
      }
    });
  }

  function scan() {
    Array.prototype.forEach.call(document.querySelectorAll('ul.product-categories'), build);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.enj2-tog');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var li = b.parentElement;
    setOpen(li, !li.classList.contains('is-open'));
  }, true);

  var t = null;
  function later() { clearTimeout(t); t = setTimeout(scan, 60); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  if (window.MutationObserver) new MutationObserver(later).observe(document.documentElement, { childList: true, subtree: true });
})();
